var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{class:_vm.customClass,attrs:{"color":_vm.color,"x-large":_vm.xLarge,"large":_vm.large,"medium":_vm.medium,"small":_vm.small,"size":_vm.size,"left":_vm.left,"right":_vm.right}},[_vm._v("\n  "+_vm._s(_vm.icon)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }